(function ($) {

    $.fn.lim2 = function (objContainer) {

        li2_w = objContainer.width();

        li2_img_w = objContainer.find("img:first-child").width();

        li2_item_w = Math.floor(li2_w / Math.floor(li2_w / li2_img_w));

        if (li2_item_w > 0) { objContainer.find(".Item").css("width", li2_item_w + "px"); }

    }

})(jQuery);